import { useQuery } from '@tanstack/react-query';
import { getActiveLanguages } from '../apis/languages';

export const languageKeys = {
    all: ['languages'],
    // Version the key so an open Admin session refreshes the cached list after
    // the English-language fallback was introduced.
    active: () => [...languageKeys.all, 'active', 'with-english-fallback'],
};

export const useActiveLanguagesQuery = () => (
    useQuery({
        queryKey: languageKeys.active(),
        queryFn: getActiveLanguages,
        select: (response) => (response?.success ? response.data || [] : []),
        staleTime: 5 * 60 * 1000,
    })
);
